"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoaderStyle = exports.InlineLoader = void 0;
var _alloyReactContentLoader = _interopRequireDefault(require("@adsk/alloy-react-content-loader"));
var _alloyReactProgressRing = _interopRequireDefault(require("@adsk/alloy-react-progress-ring"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
let LoaderStyle = exports.LoaderStyle = /*#__PURE__*/function (LoaderStyle) {
  LoaderStyle[LoaderStyle["Spinny"] = 0] = "Spinny";
  LoaderStyle[LoaderStyle["Text"] = 1] = "Text";
  return LoaderStyle;
}({});
const InlineLoader = _ref => {
  let {
    loaderStyle = LoaderStyle.Spinny
  } = _ref;
  if (loaderStyle === LoaderStyle.Spinny) {
    return /*#__PURE__*/_react.default.createElement(_alloyReactProgressRing.default, {
      size: _alloyReactProgressRing.default.SIZES.SMALL
    });
  }
  return /*#__PURE__*/_react.default.createElement(_alloyReactContentLoader.default, {
    height: 12
  }, /*#__PURE__*/_react.default.createElement("rect", {
    rx: 6,
    ry: 6,
    height: "100%",
    width: "100%"
  }));
};
exports.InlineLoader = InlineLoader;
//# sourceMappingURL=InlineLoader.js.map